import React from "react";
import LazyLoad from "react-lazyload";
import { Row, Col, Popover } from "antd";
import Router from "next/router";
import HostConfig from "$ACTIONS/Host.config";
import CMSOBJ from "$DATA/stage.live.static.id";
import Image from "next/image";
import ImageWithFallback from "@/ImageWithFallback/imgLocal";
import { Select } from "antd";
import { isGuest, getSpecificImageFormat } from "$ACTIONS/helper";

const renderIconListByFooterData = (field, footerData, supportFormat)=> {
    footerData = footerData || {};
    return !Array.isArray(footerData[field]) ? null : footerData[field].map((v,i)=>{
        let attrs = {style:{}};

        if (v.desktop_forwarding_url) {
            attrs.onClick = (function(v) {
                return () => {
                    window.open(
                        v.desktop_forwarding_url,
                        "_blank"
                    );
                    if (v.desktop_forwarding_url && typeof v.desktop_forwarding_url==='string') {
                        let u = '';
                        if (v.desktop_forwarding_url.toLowerCase().includes('bilibili')) {
                            u = 'Bilibili_socialmedia_footer_homepage'
                        } else if (v.desktop_forwarding_url.toLowerCase().includes('weibo')) {
                            u = 'Sina_socialmedia_footer_homepage'
                        }
                        if (u) {
                            Pushgtagpiwikurl(u)
                        }
                    }
                }})(v);
        }

        let deskImg = getSpecificImageFormat(v, 'desktop_image', supportFormat);
        let deskImgHover = getSpecificImageFormat(v, 'desktop_image_hover', supportFormat);
        const li = <li className={"icon-item2"} {...attrs}
                      onMouseEnter={e=>deskImgHover && e.target.setAttribute('src', deskImgHover)}
                      onMouseLeave={e=>e.target.setAttribute('src', deskImg)}>
                      <img loading="lazy" src={deskImg} style={{height:30, display:'inline-block'}} />
                      <img src={deskImgHover} style={{position:'fixed', top:-9999}} />
                  </li>
        if (!v.desktop_text) { // fix 7087
            return li;
        }

        return (<Popover
                  content={v.desktop_text}
                  title=""
                  trigger="hover"
                  overlayClassName="footer-popover"
              >{li}
              </Popover>)
        })
};

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Menudata: "",
            HlepMenudata: "",
            showWechatQrcode: false,
        };
    }
    render() {
        const { isIndexPage }= this.props;
        const IS_GUEST = isGuest();
        let sponsorImgsrc0, sponsorImgsrc1, sponsorLink0, sponsorLink1;
        const [supportFormat, footerData] = this.props.footerData;
        if (Array.isArray(footerData?.sponsorship)) {
            let len = footerData.sponsorship.length;
            if (len >= 1) {
                let the = footerData.sponsorship[0];
                sponsorImgsrc0 = getSpecificImageFormat(the, 'desktop_image', supportFormat);
                sponsorLink0 = the.desktop_forwarding_url;
            }
            if (len >= 2) {
                let the = footerData.sponsorship[1];
                sponsorImgsrc1 = getSpecificImageFormat(footerData.sponsorship[1], 'desktop_image', supportFormat);
                sponsorLink1 = the.desktop_forwarding_url;
            }
        }
        return (
            <React.Fragment>
                {isIndexPage && <LazyLoad height={454} offset={100}>
                    <div className="common-distance-wrap cooperate-wrap">
                        <div className="common-distance clear-padding">
                            <h1 className="title">合作伙伴</h1>
                            <Row>
                                <Col span={10} onClick={()=>sponsorLink0 && window.open(sponsorLink0)} style={{cursor: sponsorLink0 ? 'pointer' : 'auto'}}>
                                    <div className="cooperate-content" style={{backgroundImage:`url(${sponsorImgsrc0})`}}></div>
                                </Col>
                                <Col span={14} onClick={()=>sponsorLink1 && window.open(sponsorLink1)} style={{cursor: sponsorLink1 ? 'pointer' : 'auto'}}>
                                    <LazyLoad height={808} offset={72} once>
                                        <ImageWithFallback
                                            src={sponsorImgsrc1}
                                            width={808}
                                            height={410}
                                            alt="app-picture"
                                        />
                                    </LazyLoad>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </LazyLoad>}

                <div className="common-distance-wrap footer-platform-wrap">
                    <div className="common-distance">
                        <Row className="footer-platform">
                            <Col span={IS_GUEST ? 8 : 10}>
                                <h4>支付方式</h4>
                                <ul className="icon-list pay-kind">
                                    {renderIconListByFooterData('payment_options', footerData, supportFormat)}
                                </ul>
                            </Col>
                            <Col span={IS_GUEST ? 4 : 5}>
                                <h5>关注我们</h5>
                                <ul className="icon-list about-we">
                                    {renderIconListByFooterData('social_media', footerData, supportFormat)}
                                </ul>
                            </Col>
                            <Col span={IS_GUEST ? 4 : 5}>
                                <h5>博彩责任</h5>
                                <ul className="icon-list regulation">
                                    {renderIconListByFooterData('regulation', footerData, supportFormat)}
                                </ul>
                            </Col>
                            <Col span={4}>
                                <h5>信息安全</h5>
                                <ul className="icon-list regulation">
                                    {renderIconListByFooterData('info_security', footerData, supportFormat)}
                                </ul>
                            </Col>
                            {/* <Col span={4}>
								<h5>运营监管</h5>
								<ul className="icon-list regulation">
									<Popover content="IOVATION" title="" trigger="hover" overlayClassName="footer-popover"><a target="_blank" href="http://www.dalujiedu.com/">&nbsp;<li className="icon-item2 _12"></li></a></Popover>
								</ul>
							</Col> */}
                            {IS_GUEST && (
                                <Col span={4}>
                                    <Select
                                        className="language-select"
                                        size="small"
                                        dropdownClassName="footer-small-drop"
                                        suffixIcon={(<img src="/cn/img/footer/arrow-up-down.svg" />)}
                                        defaultValue="cn"
                                        onChange={(val) => {
                                            window.location.href = `/${val}`
                                        }}
                                    >
                                        <Select.Option
                                        value="cn"
                                        className="tlc-sprite _china"
                                        >
                                            <img src="/cn/img/footer/china.png" />
                                            <div className="selection-value">中文</div>
                                        </Select.Option>
                                        <Select.Option
                                            value="th"
                                            className="tlc-sprite item"
                                        >
                                            <img src="/cn/img/footer/thailand.png" />
                                            <div  className="selection-value">ภาษาไทย</div>
                                        </Select.Option>
                                        <Select.Option
                                            value="vn"
                                            className="tlc-sprite item"
                                        >
                                            <img src="/cn/img/footer/vietnam.png" />
                                            <div className="selection-value">Tiếng Việt</div>
                                        </Select.Option>
                                    </Select>
                                </Col>
                            )}
                        </Row>
                        <div>
                            <h4>游戏平台</h4>
                            <Row gutter={16}>
                                {!Array.isArray(footerData?.gaming_platform) ? null : footerData.gaming_platform.map((v, i) => {
                                    let deskImg = getSpecificImageFormat(v, 'desktop_image', supportFormat);
                                    let deskImgHover = getSpecificImageFormat(v, 'desktop_image_hover', supportFormat);
                                    return (
                                        <Col
                                            span={3}
                                            onClick={()=>v.desktop_forwarding_url && window.open(v.desktop_forwarding_url)}
                                            style={{
                                                cursor: v.desktop_forwarding_url ? 'pointer' : 'auto',
                                                width: "140px",
                                                height: "36px",
                                                marginTop: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                            key={i}
                                        >
                                            <img loading="lazy"
                                                src={deskImg||'/cn/img/logo.svg'}
                                                onMouseEnter={e=>deskImgHover && e.target.setAttribute('src', deskImgHover)}
                                                onMouseLeave={e=>e.target.setAttribute('src', deskImg)}
                                                width={140}
                                                height={36}
                                                alt={v.desktop_text}
                                            />
                                            <img src={deskImgHover} style={{position:'fixed', top:-9999}} />
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="common-distance-wrap footer-copyright-wrap">
                    <div className="common-distance clear-padding">
                        <div className="copyright-content">
                            <p>FUN88 属于 Omega Sports Solutions N.V 运营</p>
                            <p>FUN88 由 Curaçao Gaming Control Board 授权及监管</p>
                            <p>FUN88 © 版权所有违者必究</p>
                            <p style={{margin:'6px 0'}}><a href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJak5LY0ZSWVNVTlVTbVo1ZG01RWJWRkdXRXRsYTJjOVBTSXNJblpoYkhWbElqb2lXR2RQY25aa1lqQTRaVkUzWjAxRWVGSnNVRmc1WnowOUlpd2liV0ZqSWpvaVpHUTRNV0kwTkRrME56UmpOekF5TldWbU16QTBNV1V4TURNelpUUmlZbUV4T1RNME9EQTRZMk15T1RGaVlUTmpOMkl6TkdZNU9EUTBOVGd6TmpFNE55SXNJblJoWnlJNklpSjk=" target="_blank"><img src="/cn/img/License.png" alt="cert.gcb.cw" /></a></p>
                            <p>Curaçao Gaming Control Board</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
